/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ComponentType, lazy, Suspense } from "react";
import { useEffect } from "react";
import ClientOnly from "./ClientOnly";

export const NullLoader = () => null;

// TODO: Improve the types here to remove `any`. I couldn't find a way to get
// generics to work with the `dynamicImports` array. Maybe we can remove the
// array as we never pass more than one import to a single LazyLoader anyway.
type Props<T extends ComponentType<any>> = {
  delay?: number;
  dynamicImport(): Promise<{ default: T }>;
  LoadingComponent?(): JSX.Element | null;
  props?: any;
};

export default function LazyLoader<T extends ComponentType<any>>({
  delay = 7000,
  dynamicImport,
  LoadingComponent = NullLoader,
  props,
}: Props<T>) {
  let timeoutHandle: NodeJS.Timeout;
  useEffect(() => {
    return () => {
      clearTimeout(timeoutHandle);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LazyComponent = lazy(async () => {
    const [component] = await Promise.all([
      dynamicImport(),
      new Promise((resolve) => {
        timeoutHandle = setTimeout(resolve, delay);
      }),
    ]);
    return component;
  });

  return (
    <ClientOnly>
      <Suspense fallback={<LoadingComponent />}>
        <LazyComponent {...props} />
      </Suspense>
    </ClientOnly>
  );
}
